export const i18nConditionDeviationPage = {
  tabs: {
    ACTION_ISSUED: 'Investigando/Emisión',
    COMPLETED: 'Completado',
    ALL: 'Todos',
  },
  newCd: 'Nuevo DC',
  action_status: {
    INVESTIGATING: 'Investigando',
    ACTION_ISSUED: 'Acción Emitida',
    COMPLETED: 'Completado',
    CANCELED: 'Cancelado',
  },
  sap_note_status: {
    'open-critical': 'Abierto crítico',
    'open-non-critical': 'Abierto no crítico',
    closed: 'Cerrado',
    offline: 'No encontrado',
    not_found: 'No encontrado',
    not_informed: 'No informado',
  },
  columns: {
    id: 'ID',
    asset: 'Activo',
    dimension: 'Dimensión',
    deviation_start: 'Dev. start',
    deviation_end: 'Dev. end',
    last_update_date: 'Última edición',
    action_status: 'Estado de la acción',
    condition_evaluation: 'Condición',
    diagnosis: 'Diagnóstico',
    recommended_action: 'Acción recomendada',
    sap_note: 'Nota',
  },
  notFound: 'No encontrado',
  status_count_panel: {
    total: { caption: 'DCs' },
    severity: {
      severity: {
        status: {
          title: 'Severity',
          3: 'Alta',
          4: 'Muy Alta',
          2: 'Media',
          1: 'Baja',
          modec: {
            5: 'Condición Crítica',
            4: 'Problema Potencial',
            3: 'Condición de Alarma',
            2: 'No Monitoreado',
            1: 'No Operado',
            0: 'Condición Normal',
          },
        },
      },
      status: {
        title: 'Evaluación de la condición',
        POTENTIAL_PROBLEM: 'Problema potencial',
        CRITICAL_CONDITION: 'Crítico',
        ALARM_CONDITION: 'Alarmante',
        NORMAL_CONITION: 'Normal',
      },
    },
    status: {
      total: { title: 'Total', total: 'DCs' },
      action_status: {
        title: 'Estado de la acción',
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Acción Emitida',
        CANCELED: 'Cancelado',
        COMPLETED: 'Completado',
      },
      classification: { title: 'Clasificación', Useful: 'Útil', 'Not Useful': 'No Útil' },
    },
  },
  error: {
    noOpenConditionDeviations: 'No hay desviaciones de condición abiertas en este momento.',
    noClosedConditionDeviations:
      'No existen desviaciones de condición cerrada en el período seleccionado.',
    noConditionDeviations: 'No hay desviaciones de condición en el período seleccionado.',
  },
};
